import React from 'react';

const SectionUnlock = ({ sectionId, children, unlockedSections }) => {
  const isUnlocked = unlockedSections.has(sectionId);
  
  return (
    <div className={`transition-all duration-1000 relative ${
      isUnlocked 
        ? 'opacity-100 transform translate-y-0' 
        : 'opacity-30 transform translate-y-8'
    }`}>
      {!isUnlocked && (
        <div className="absolute inset-0 flex items-center justify-center z-10 bg-black bg-opacity-20 rounded-lg">
          <div className="text-center text-white">
            <div className="text-4xl mb-2">🔒</div>
            <p className="text-lg font-medium">Scroll to unlock this section</p>
          </div>
        </div>
      )}
      {children}
    </div>
  );
};

export default SectionUnlock;